import {
  assigneeIdsMatch,
  hasAssigneeFilterValue,
  normalizeAssigneeId,
} from './assigneeFilters';

const ALL_STATUS = 'all';
const DEFAULT_STATUS = 'open';

const conversationMatchesAssigneeId = (conversation, selectedAssigneeId) => {
  if (!hasAssigneeFilterValue(selectedAssigneeId)) {
    return true;
  }

  const assignee =
    conversation && conversation.meta && conversation.meta.assignee;
  return Boolean(assignee) && assigneeIdsMatch(assignee.id, selectedAssigneeId);
};

const conversationMatchesBasicFilters = ({
  conversation,
  currentInboxId,
  currentUserId,
  filters = {},
} = {}) => {
  if (!conversation) {
    return false;
  }

  const inboxId = Number(currentInboxId);
  if (
    Number.isFinite(inboxId) &&
    inboxId !== 0 &&
    Number(conversation.inbox_id) !== inboxId
  ) {
    return false;
  }

  const status = filters.status || DEFAULT_STATUS;
  if (status && status !== ALL_STATUS && conversation.status !== status) {
    return false;
  }

  const assignee = conversation.meta && conversation.meta.assignee;
  if (filters.assigneeType === 'me') {
    return Boolean(assignee) && assigneeIdsMatch(assignee.id, currentUserId);
  }

  if (filters.assigneeType === 'unassigned') {
    return !assignee;
  }

  return true;
};

const buildChatListConversationList = ({
  chatLists = [],
  currentInboxId,
  currentUserId,
  directConversations = [],
  filters = {},
  hasAppliedFiltersOrActiveFolders = false,
  showDirectConversations = false,
} = {}) => {
  if (showDirectConversations) {
    return directConversations;
  }

  const baseConversationList = [...chatLists];

  if (hasAppliedFiltersOrActiveFolders) {
    return baseConversationList;
  }

  return baseConversationList.filter((conversation) =>
    conversationMatchesBasicFilters({
      conversation,
      currentInboxId,
      currentUserId,
      filters,
    })
  );
};

const filterConversationIdsNotMatchingFilters = ({
  conversationIds = [],
  getConversationById = () => null,
  matchesFilters = () => true,
} = {}) => {
  const safeIds = Array.isArray(conversationIds) ? conversationIds : [];
  return safeIds.filter((conversationId) => {
    const conversation = getConversationById(conversationId);
    return Boolean(conversation) && !matchesFilters(conversation);
  });
};

export {
  buildChatListConversationList,
  conversationMatchesAssigneeId,
  conversationMatchesBasicFilters,
  filterConversationIdsNotMatchingFilters,
  normalizeAssigneeId as normalizeId,
};
